import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';

import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { IUser } from '../../types/User/User';

export default function useOrganisationUsers() {
  const { get } = useApiHelper();

  const users = useQuery({
    queryKey: ['organisation', 'users'],
    queryFn: () =>
      get<IDefaultResponseWithData<IUser>>('/v1/organisation/users').then(
        (res) => res.data.data
      ),
  });

  return {
    users,
  };
}
